import AccessoryCommon from "./accessoryCommon";
import {GRAB_BARS_POSITIONS, METADATA} from "../../constants";
import {Shower} from "../../parts/shower";
// import {IS_QKB_UI} from "../../../../../config";

export default class ShampooShelf extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shampoo_shelf';
    this.partName = 'Shampoo Shelf';
    this.translateId = "visualizer.bathroom.accessories.shampoo_shelf";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {};
      GRAB_BARS_POSITIONS.forEach(pos => {
        this.layerPositions[pos] = null
      })
    }
  }

  load(dbFeature) {
    if (dbFeature.metaData["Side"]) {
      dbFeature.metaData["layerPosition"] = dbFeature.metaData["WallPosition"]?.includes("Vertical")
        // WallPosition: ['Vertical'] or ['Tub']
        ? dbFeature.metaData["Side"][0] + "V" // "LV" or "RV" // vertical grab bars
        : dbFeature.metaData["WallPosition"]?.includes("Tub")
          ? "B" + dbFeature.metaData["Side"][0]
          : dbFeature.metaData["Side"][0]
      // L,R,C is usual shower positions, LV and RV are wall mounted shower positions,
      // BL, BC, BR are bathtub wall positions on Room Layout 11
    } else {
      dbFeature.metaData["layerPosition"] = METADATA.LeftSide;
    }
    const partNumber = (dbFeature.metaData["layerPosition"] === GRAB_BARS_POSITIONS[0]
      || dbFeature.metaData["layerPosition"] === GRAB_BARS_POSITIONS[2]) ? 1 : 2;
    return super.load_(dbFeature, new ShampooShelf(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  // navigationSubItems(...props) {
  //   if (IS_QKB_UI) {
  //     return this.navigationSubItemsSimple(...props)
  //   }
  //   return super.navigationSubItems(...props);
  // }

  handleClick() { // "this" is feature!! not the feature group
    super.handleClick();
    const parent = this.getParent();
    const accessoriesParent = parent.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerSize !== "60" && parent.activeFeature) {
      parent.layerPositions[parent.activeFeature.metaData["layerPosition"]] = parent.activeFeature;
    }
    // parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
  }

  isSideWallMountedGrabBar() { // feature method
    // return hardCodeIsAmericanStandard() || this.metaData["Placement"]?.includes("Wall");
    return !!this.metaData["IsWallMounted"] || this.metaData["WallPosition"] // they are added for the same purpose
  }

  checkCenterGrabWall(clickedPosition) {
    // L or R and C can't be together, but in case if we have a new Placement Wall metadata we can keep it
    if (!clickedPosition || !this.layerPositions[clickedPosition]) {
      // we unchecked enabled toggle, why do check other layers
      return
    }
    Object.keys(this.layerPositions).forEach(position => {
      if (clickedPosition === "C") {
        if (position !== "C" && !(this.layerPositions[position]?.isSideWallMountedGrabBar?.())) {
          this.layerPositions[position] = null;
        }
      } else if (position === "C" && !(this.layerPositions[clickedPosition]?.isSideWallMountedGrabBar?.())) {
        this.layerPositions[position] = null;
      }
    })
  }

  showLayerPositionsModal(forFeature) {
    // const showerParent = this.getParent().layout.parts[Shower.id];
    // if (showerParent.showerSize() !== "60") {
    //   return false
    // }
    return super.showLayerPositionsModal(forFeature)
  }

}
